import { createContext } from 'react';

interface ICustomWindow extends Window {
  initialAppState?: any;
}

const customWindow: ICustomWindow = window;

const LaunchDarklyContext = createContext(
  customWindow.initialAppState.launchDarkly,
);

export default LaunchDarklyContext;
